window.modalState = Vue.reactive({
    openModals: new Set(),
    sharedFadeout: null,
    init() {
      this.sharedFadeout = document.getElementById("shared-fadeout");
      if (this.sharedFadeout) {
        this.sharedFadeout.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.closeLastModal();
        });
      }
    },
    lockScroll() {
      if (this.openModals.size > 0) {
        document.documentElement.classList.add("overflow-hidden");
      }
    },
    unlockScroll() {
      if (this.openModals.size === 0) {
        document.documentElement.classList.remove("overflow-hidden");
      }
    },
    addModal(modalId) {
      this.openModals.add(modalId);
      this.lockScroll();
      // Show shared fadeout if it's not search modal
      if (modalId !== 'search' && this.sharedFadeout) {
        this.sharedFadeout.classList.remove("hidden");
        this.sharedFadeout.classList.remove("opacity-0");
        this.sharedFadeout.classList.add("opacity-100");
        this.sharedFadeout.classList.remove("pointer-events-none");
        this.sharedFadeout.classList.add("pointer-events-auto");
      }
    },
    isCartOpened() {
      return this.openModals.has('side-panel-cart');
    },
    removeModal(modalId) {
      this.openModals.delete(modalId);
      this.unlockScroll();

      // Only hide fadeout if there are no non-search modals left
      const hasNonSearchModals = Array.from(this.openModals).some(id => id !== 'search');

      if (modalId !== 'search' && this.sharedFadeout && !hasNonSearchModals) {
        this.sharedFadeout.classList.add("opacity-0");
        this.sharedFadeout.classList.remove("opacity-100");
        this.sharedFadeout.classList.add("pointer-events-none");
        this.sharedFadeout.classList.remove("pointer-events-auto");

        // Wait for transition to complete before hiding
        setTimeout(() => {
          const stillHasNonSearchModals = Array.from(this.openModals).some(id => id !== 'search');
          if (!stillHasNonSearchModals && this.sharedFadeout) {
            this.sharedFadeout.classList.add("hidden");
          }
        }, 300);
      }
    },
    closeLastModal() {
      if (this.openModals.size > 0) {
        const lastModal = Array.from(this.openModals).pop();
        if (lastModal === 'cart') {
          toggleCart();
        } else if (lastModal === 'filters') {
          toggleFilters();
        } else if (lastModal === 'search') {
          toggleSearch();
        } else if (lastModal.startsWith('side-panel-')) {
          // Close side panel
          const panelId = lastModal.replace('side-panel-', '');
          window.closePanel(panelId);
        }
      }
    }
  });

  // Initialize modalState
  document.addEventListener('DOMContentLoaded', () => {
    window.modalState.init();
  });

  function toggleModal(type, content) {
    const modalId = type === 'search' ? 'search' :
                   type === 'filters' ? 'filters' :
                   `${type}-drawer`;
    const fadeoutId = type === 'search' ? 'search-fadeout' : 'shared-fadeout';

    const modal = document.getElementById(modalId);
    const fadeout = document.getElementById(fadeoutId);

    if (!modal || (type === 'search' && !fadeout)) {
      console.error(`${type} modal not found. Make sure the ${type}-modal.liquid snippet is included in the page.`);
      return;
    }
    if (modal.classList.contains('hidden')) {
      // Opening
      modal.classList.remove('hidden');
      if (fadeout) fadeout.classList.remove('hidden');
      window.modalState.addModal(type);
      // Force a reflow
      modal.offsetHeight;
      modal.classList.remove('translate-x-full');

      if (type === 'search') {
        window.addForceNavbarWhite();
      }
    } else {
      // Closing
      modal.classList.add('translate-x-full');

      // Handle search fadeout separately
      if (type === 'search' && fadeout) {
        fadeout.classList.add('hidden');
      }

      // Wait for the transition to complete before hiding
      modal.addEventListener(
        "transitionend",
        () => {
          if (modal.classList.contains("translate-x-full")) {
            modal.classList.add("hidden");
            window.modalState.removeModal(type);
            if (type === 'search') {
              window.removeForceNavbarWhite();
            }
          }
        },
        { once: true }
      );
    }
  }

  function toggleFilters() {
    const modal = document.getElementById('filters');

    // If opening filters and seo.hidden filter is not present, add it without reload
    if (modal && modal.classList.contains('hidden')) {
      const urlParams = new URLSearchParams(window.location.search);
      if (!urlParams.has('filter.p.m.seo.hidden')) {
        urlParams.set('filter.p.m.seo.hidden', '0');
        const newUrl = `${window.location.pathname}?${urlParams.toString()}`;

        // Update URL without reload
        window.history.replaceState({}, '', newUrl);

        // Fetch and update the collection content
        fetch(`${newUrl}&section_id=main-collection-product-grid`)
          .then(response => response.text())
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');

            // Update the main collection content
            const currentCollection = document.querySelector('[data-section-type="collection"]') ||
                                     document.querySelector('#main-collection-product-grid') ||
                                     document.querySelector('.collection-grid');
            const newCollection = doc.querySelector('[data-section-type="collection"]') ||
                                 doc.querySelector('#main-collection-product-grid') ||
                                 doc.querySelector('.collection-grid');

            if (currentCollection && newCollection) {
              currentCollection.innerHTML = newCollection.innerHTML;
            }

            // Update filters content if needed
            const currentFilters = document.getElementById('filters');
            const newFilters = doc.getElementById('filters');
            if (currentFilters && newFilters) {
              currentFilters.innerHTML = newFilters.innerHTML;
            }

            // Re-initialize filter event listeners
            if (window.initializeFilterListeners) {
              window.initializeFilterListeners();
            }
          })
          .catch(error => {
            console.error('Error updating filters:', error);
            // Fallback to reload if AJAX fails
            window.location.href = newUrl;
          });
      }
    }

    toggleModal('filters');
  }

  function toggleSearch() {
    toggleModal('search');
  }

  // Listen for Shopify cart updates
  document.addEventListener("cart:refresh", function (event) {
    console.log("cart:refresh", event);
    store.getCart();
  });

  function toggleDetailsAccordion(prefix, productId) {
    const accordion = document.getElementById(`details-accordion-${prefix}-${productId}`);
    const button = document.querySelector(`button[onclick*="toggleDetailsAccordion('${prefix}', '${productId}')"]`);
    const showText = button?.querySelector('.show-text');
    const hideText = button?.querySelector('.hide-text');

    if (accordion) accordion.classList.toggle('hidden');
    if (showText) showText.classList.toggle('hidden');
    if (hideText) hideText.classList.toggle('hidden');
  }

  // Side panel toggle
  window.openPanel = (panelId) => {
    document.getElementById(`side-panel-drawer-${panelId}`)?.classList.remove('translate-x-full');
    window.modalState.addModal(`side-panel-${panelId}`);
  };

  window.closePanel = (panelId) => {
    const elements = document.querySelectorAll(`#side-panel-drawer-${panelId}`);
    elements.forEach(element => {
      if (!element.classList.contains('translate-x-full')) {
        element.classList.add('translate-x-full');
      }
    });
    window.modalState.removeModal(`side-panel-${panelId}`);
  };
  // end side panel toggle

  function toggleCart() {
    if (window.modalState.openModals.has('side-panel-cart')) {
      window.closePanel('cart');
    } else {
      window.openPanel('cart');
      // Fire event when cart is opened
      window._conv_q = window._conv_q || [];
      window._conv_q.push({
        what: "triggerLocation",
        params: {
          locationId: "10014866" // Convert Experiences - cart is opened
        }
      });
    }
  }

  window.toggleCart = toggleCart;
  window.toggleFilters = toggleFilters;
  window.toggleSearch = toggleSearch;
  window.toggleDetailsAccordion = toggleDetailsAccordion;